import { useNavigate } from 'react-router-dom';

const ClientPortalBanner = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 to-emerald-700">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-semibold mb-6">
              <i className="ri-shield-check-line mr-2"></i>
              Secure Client Portal
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Access Your Tax Documents Anytime, Anywhere
            </h2>
            <p className="text-xl text-teal-50 mb-8">
              Our secure client portal gives you 24/7 access to your tax documents, proposals, contracts, and invoices. Upload documents, track your tax preparation progress, and communicate with your tax professional—all in one place.
            </p>
            <div className="flex flex-wrap gap-4">
              <button
                onClick={() => navigate('/client-portal')}
                className="px-8 py-4 bg-white text-teal-700 font-bold rounded-xl hover:bg-teal-50 transition-all shadow-lg whitespace-nowrap"
              >
                <i className="ri-login-box-line mr-2"></i>
                Sign In to Portal
              </button>
              <button
                onClick={() => navigate('/tax-calculator')}
                className="px-8 py-4 bg-teal-500 text-white font-bold rounded-xl hover:bg-teal-400 transition-all border-2 border-white/30 whitespace-nowrap"
              >
                <i className="ri-calculator-line mr-2"></i>
                Calculate Tax Liability
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-file-upload-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Upload Documents</h3>
              <p className="text-teal-50 text-sm">Securely upload W-2s, 1099s, and other tax documents</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-file-text-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">View Proposals</h3>
              <p className="text-teal-50 text-sm">Review and accept service proposals instantly</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-edit-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">E-Signature</h3>
              <p className="text-teal-50 text-sm">Sign contracts digitally with secure e-signature</p>
            </div>

            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
              <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-bill-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">Pay Invoices</h3>
              <p className="text-teal-50 text-sm">View and pay invoices with multiple payment options</p>
            </div>
          </div>
        </div>

        {/* Tax Calculator CTA */}
        <div className="mt-12 bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 bg-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-calculator-line text-white text-3xl"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">Free Tax Liability Calculator</h3>
                <p className="text-teal-50">
                  Calculate your estimated tax liability instantly. Upload your tax documents or enter information manually for IRS-compliant calculations.
                </p>
              </div>
            </div>
            <button
              onClick={() => navigate('/tax-calculator')}
              className="px-8 py-4 bg-white text-teal-700 font-bold rounded-xl hover:bg-teal-50 transition-all shadow-lg whitespace-nowrap flex-shrink-0"
            >
              Try Calculator
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientPortalBanner;
